import { fetchData } from "@request";
import { getQueryParams } from "@request/helpers";

export type AdminBalancesResponse = {
  ern_balance: number;
  frozen_balance: number;
  merch_balance: number;
  our_balance: number;
  agent_team_lead_balances: number;
};

export const getAdminBalancesApi = async () => {
  try {
    const response = await fetchData<AdminBalancesResponse>({
      url: `api/v1/admin/balances`,
    });

    return response;
  } catch (error) {
    console.error("getAdminBalancesApi failed:", error);
    throw error;
  }
};

export type TradeBalanceRequest = {
  date_start: number;
  date_end: number;
};

export type TradeBalanceResponse = {
  our_balance: number;
  pay_in: number;
  pay_out: number;
};

export const getTradeBalanceApi = async (data?: TradeBalanceRequest) => {
  try {
    const queryParams = getQueryParams(data);

    const response = await fetchData<TradeBalanceResponse>({
      url: `api/v1/admin/trade-balances?${queryParams}`,
    });

    return response;
  } catch (error) {
    console.error("getTradeBalance failed:", error);
    throw error;
  }
};

export type AddAdminWalletRequest = {
  wallet: string;
};

export type AddAdminWalletResponse = {
  message: string;
};

export const addAdminWalletApi = async (data: AddAdminWalletRequest) => {
  try {
    const response = await fetchData<AddAdminWalletResponse>({
      url: `api/v1/admin/wallets`,
      method: "POST",
      data,
    });

    return response;
  } catch (error) {
    console.error("addAdminWallet failed:", error);
    throw error;
  }
};

export const getAdminWalletApi = async () => {
  try {
    const response = await fetchData<AdminWallets>({
      url: `api/v1/admin/wallets`,
    });

    return response;
  } catch (error) {
    console.error("getAdminWalletApi failed:", error);
    throw error;
  }
};

export type AdminWallets = string[]

export const getAdminWalletsForWithdrawalsApi = async () => {
  try {
    const response = await fetchData<AdminWallets>({
      url: "api/v1/admin/wallets-for-withdrawals",
    });
    return response;
  } catch (err) {
    console.error("getAdminWalletsForWithdrawalsApi failed:", err);
    throw err;
  }
};

export type AddAdminWithdrawalWalletsRequest = {
  wallet: string;
}

export const addAdminWalletsForWithdrawalsApi = async (data: AddAdminWithdrawalWalletsRequest) => {
  try {
    const response = await fetchData<string>({
      url: "api/v1/admin/wallets-for-withdrawals",
      method: "POST",
      data
    });
    return response;
  } catch (err) {
    console.error("addAdminWalletsForWithdrawalsApi failed:", err);
    throw err;
  }
};

export type DeleteAdminWithdrawalWalletsRequest = {
  address: string;
}

export const deleteAdminWalletsForWithdrawalsApi = async (data: DeleteAdminWithdrawalWalletsRequest) => {
  try {
    const response = await fetchData<string>({
      url: `api/v1/admin/wallets-for-withdrawals/${data.address}`,
      method: "PUT",
    });
    return response;
  } catch (err) {
    console.error("deleteAdminWalletsForWithdrawalsApi failed:", err);
    throw err;
  }
};